'use strict'

import {App} from './App'

const app = new App()
const company = document.getElementById('js-top-company')
const tech = document.querySelector('.top-tech')
const techAudio = document.querySelector('.top-tech-audio')
const techVideo = document.querySelector('.top-tech-video')
const techBg = document.querySelector('.top-tech__bg')

// const navItem = document.querySelectorAll('.header-nav__item a')

// navItem.forEach(el => {
//   el.style.color = 'green'
//   el.addEventListener('click', (e) => {
//     e.preventDefault()
//     el.style.color = 'red'
//   })
// })

const isSp = () => window.innerWidth < 767
const setheightTechBgSp = () => {
  const techBgHeight = tech.clientHeight - 60 - 90 - techAudio.clientHeight - techVideo.clientHeight
  techBg.style.height = techBgHeight + 'px'
}

let timer = false

if (isSp()) setheightTechBgSp();
window.addEventListener('resize', () => {
  if (timer !== false) {
    clearTimeout(timer);
  }
  timer = setTimeout(() => {
    setheightTechBgSp();
  }, 100);
})

window.addEventListener('scroll', () => {
  app.scrollTop = window.pageYOffset
  const border = company.getBoundingClientRect().top + app.scrollTop
  if (app.scrollTop >= border && !app.header.classList.contains('is-black')) {
    app.header.classList.add('is-black')
  } else if (app.scrollTop < border && app.header.classList.contains('is-black')) {
    app.header.classList.remove('is-black')
  }
})
